import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../hooks/useToast';
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import { FaSpinner } from 'react-icons/fa';
import BackButton from '../components/common/BackButton/BackButton';
import './RecuperarSenha.css';

const logo = '/logo_gif.gif';

const particlesOptions = {
  background: { color: { value: '#F4F7F6' } },
  fpsLimit: 60,
  interactivity: { events: { onHover: { enable: true, mode: 'repulse' } } },
  particles: {
    color: { value: '#A0AEC0' },
    links: { color: '#CBD5E0', distance: 150, enable: true, opacity: 0.4, width: 1 },
    move: { direction: 'none', enable: true, outModes: { default: 'bounce' }, speed: 1 },
    number: { density: { enable: true, area: 800 }, value: 80 },
    opacity: { value: 0.5 },
    shape: { type: 'circle' },
    size: { value: { min: 1, max: 3 } },
  },
  detectRetina: true,
};

const RecuperarSenha = () => {
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const { resetPassword } = useAuth();
  const { addToast } = useToast();
  const navigate = useNavigate();

  const particlesInit = useCallback(async (engine) => {
    await loadSlim(engine);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await resetPassword(email);
      addToast('Instruções enviadas para o seu e-mail.', 'success');
      navigate('/login');
    } catch (error) {
      addToast('Erro ao enviar o e-mail de recuperação.', 'error');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="hero-section">
      <div className="hero-column-left">
        <Particles id="tsparticles" init={particlesInit} options={particlesOptions} />
        <div className="storytelling">
          <img src={logo} alt="Logo Mago" className="login-logo-main" />
          <h1 className="headline">Esqueceu sua senha? <span>Não se preocupe.</span></h1>
          <p className="support-text">
            Insira seu e-mail para redefinir sua senha e voltar a ter acesso à sua conta.
          </p>
        </div>
      </div>
      <div className="hero-column-right">
        <div className="login-form-panel">
          <h2>Recuperar acesso</h2>
          <p className="form-subtitle">Digite seu e-mail cadastrado para receber as instruções de recuperação.</p>
          <form onSubmit={handleSubmit} className="login-form">
            <div className="input-group">
              <label htmlFor="email">E-mail</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu.email@exemplo.com"
                required
                autoComplete="email"
              />
            </div>
            <button type="submit" className="login-button" disabled={sending} aria-busy={sending}>
              {sending ? (
                <>
                  <FaSpinner className="icon-spin" />
                  <span>Enviando...</span>
                </>
              ) : (
                'Enviar link de recuperação'
              )}
            </button>
          </form>
          <BackButton label="Voltar para o Login" onClick={() => navigate('/login')} style={{ marginTop: '1rem' }} />
        </div>
      </div>
    </div>
  );
};

export default RecuperarSenha;
